import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const PaceDashboardStyles = makeStyles((theme: Theme) =>
    createStyles({
        engagementHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing(2),
            padding: theme.spacing(0, 2),
        },
        headerInner: {
            paddingBottom: theme.spacing(3),
        },
        headerTitle: {
            fontSize: 32,
        },
        hiperLinkIcon: {
            fontSize: 14,
            marginLeft: theme.spacing(1),
            color: theme.palette.others.darkBlue,
        },
        hubAnalysisContainer: {
            position: "sticky",
            backgroundColor: theme.palette.background.paleBlue,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: theme.spacing(2),
            top: 104,
            zIndex: 1000,
        },
        mainContainer: {
            padding: theme.spacing(2, 0),
        },
        paceStatusButtonContainer: {
            display: "flex",
            gap: "16px",
            marginBottom: theme.spacing(2),
            padding: theme.spacing(0, 2),
        },
        pageDescription: {
            fontSize: 16,
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(2),
            padding: theme.spacing(0, 2),
        },
        selectBehaviourPaper: {
            width: 260,
            borderRadius: theme.spacing(3),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
        },
        selectField: {
            "& .MuiSelect-select": {
                paddingTop: theme.spacing(2.7),
                paddingBottom: theme.spacing(2.7),
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
    })
);

export default PaceDashboardStyles;
